import BarGraph from "./BarGraph";
import { determineAvg } from "../body-composition.helper";
import NoData from "./NoData";
import SvgIcon from "../../../../../parts/SvgIcon";

const Header = ({ date, athlete, organizationCoachParam }) => (
  <header>
    <div>
      <h4>Heart Rate Variability (HRV)</h4>
      <p className="p4">(average for week)</p>
    </div>
    <a
      className="composition-see-more mobile-hidden"
      href={`/athlete-portal/metrics/hrv?date=${date}&athlete=${athlete}&checkin=true${organizationCoachParam}`}
    >
      <span>See more</span>
      <SvgIcon
        src="/img/new-icons/arrow-square-right-gradient.svg"
        noFilterOnLight={true}
      />
    </a>
  </header>
);

const Results = ({ data, avg, previousAverage }) => {
  const increase = avg - previousAverage || 0;
  const percentage =
    Math.round(((avg - previousAverage) / previousAverage) * 100) || 0;
  const isPositivePercentage = increase >= 0;

  const hasData = data.some((d) => !!d.hrv);

  return (
    <div>
      {hasData && (
        <div>
          <div>
            {!!previousAverage && (
              <span
                className={
                  isPositivePercentage ? "text-[--success]" : "text-[--danger]"
                }
              >
                <img
                  src={
                    isPositivePercentage
                      ? "/img/svg/green-up-icon.svg"
                      : "/img/svg/red-down-icon.svg"
                  }
                />{" "}
                {percentage}%
              </span>
            )}
            <div>
              <h1>{avg}</h1>
              <span className="composition-second-font">ms</span>
            </div>
          </div>
        </div>
      )}
      <div className="adherence-chart-new">
        <BarGraph
          data={data}
          graphId={"hrv-graph"}
          targetValue={"hrv"}
          average={avg}
          type="Line"
          units="ms"
        />
      </div>
    </div>
  );
};

const HrvStats = ({
  data,
  date,
  athlete,
  previousWeek,
  organizationCoachParam,
}) => {
  const average = determineAvg(data, "hrv");
  const previousAverage = determineAvg(previousWeek, "hrv");

  return (
    <article id="steps-data">
      <Header
        date={date}
        athlete={athlete}
        organizationCoachParam={organizationCoachParam}
      />
      {data.length ? (
        <Results data={data} avg={average} previousAverage={previousAverage} />
      ) : (
        <NoData />
      )}
      <footer className="only-show-mobile">
        <a
          className="composition-see-more"
          href={`/athlete-portal/metrics/hrv?date=${date}&athlete=${athlete}&checkin=true${organizationCoachParam}`}
        >
          <span>See more</span>
          <SvgIcon
            src="/img/new-icons/arrow-square-right-gradient.svg"
            noFilterOnLight={true}
          />
        </a>
      </footer>
    </article>
  );
};

export default HrvStats;
